import { useEffect, useRef } from 'react';

/**
 * Stable event listener hook.
 * Ensures the latest handler is used without re-registering the listener.
 */
export function useEventListener(target, type, handler, options) {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const element = typeof target === 'function' ? target() : target;
    if (!element?.addEventListener) return;

    const listener = event => handlerRef.current?.(event);
    element.addEventListener(type, listener, options);
    return () => element.removeEventListener(type, listener, options);
  }, [target, type, options]);
}
